"use client"

import Button from "components/Buttons/Button"
import CTA1IMG from "images/about/cta/CTA1.png"
import CTA1MobileIMG from "images/about/cta/CTA1Mobile.png"
import CTA2IMG from "images/about/cta/CTA2.png"
import CTA2MobileIMG from "images/about/cta/CTA2Mobile.png"
import CTA3IMG from "images/about/cta/CTA3.png"
import CTA3MobileIMG from "images/about/cta/CTA3Mobile.png"
import CTA4IMG from "images/about/cta/CTA4.png"
import CTA4MobileIMG from "images/about/cta/CTA4Mobile.png"
import CTA5IMG from "images/about/cta/CTA5.png"
import StaticImage from "library/StaticImage"
import { css, f, styled } from "library/styled"
import { useMedia } from "library/useMedia"
import colors from "styles/colors"
import textStyles from "styles/text"
import links from "utils/links"

export default function CareersCTA() {
	const mobile = useMedia(false, false, false, true)

	const images = [
		{
			id: 1,
			src: CTA1IMG,
			mobileSrc: CTA1MobileIMG,
			alt: "",
		},
		{
			id: 2,
			src: CTA2IMG,
			mobileSrc: CTA2MobileIMG,
			alt: "",
		},
		{
			id: 3,
			src: CTA3IMG,
			mobileSrc: CTA3MobileIMG,
			alt: "",
		},
		{
			id: 4,
			src: CTA4IMG,
			mobileSrc: CTA4MobileIMG,
			alt: "",
		},
		{
			id: 5,
			src: CTA5IMG,
			mobileSrc: CTA5IMG,
			alt: "",
		},
	]

	return (
		<Wrapper>
			<Inner>
				<Top>
					<Title>
						<GreenText>Careers</GreenText> at Arlo
					</Title>
					<Subcontent>
						<Button href={links.contact} variant="dark">
							Get a Quote Started Today
						</Button>
						<Text>
							Join hundreds of businesses who trust Arlo to offer health
							insurance that works the way it should.
						</Text>
					</Subcontent>
				</Top>
				<Bottom>
					<BackgroundColor />
					<Images>
						{images.map((image) => (
							<ImageWrapper key={image.id}>
								<Image
									src={mobile ? image.mobileSrc : image.src}
									alt={image.alt}
								/>
							</ImageWrapper>
						))}
					</Images>
				</Bottom>
			</Inner>
		</Wrapper>
	)
}

const Wrapper = styled("section", {
	...f.responsive(css`
		display: grid;
		place-items: center;
		width: 100%;
		background: ${colors.greenMain};
		border-radius: 20px 20px 0 0;
	`),
})

const Inner = styled("div", {
	...f.unresponsive(css`
		border: 1px solid ${colors.green400};
	`),
	...f.responsive(css`
		width: 1376px;
		padding-top: 144px;
		margin: 80px auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 16px;
		overflow: clip;
	`),
	...f.tablet(css`
		width: 960px;
		padding-top: 124px;
	`),
	...f.mobile(css`
		width: 327px;
		padding-top: 82px;
		margin: 48px 0 138px;
	`),
})

const Top = styled("div", {
	...f.responsive(css`
		width: 1115px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 54px;
	`),
	...f.tablet(css`
		width: 933px;
	`),
	...f.mobile(css`
		width: 327px;
		gap: 52px;
	`),
})

const Title = styled("h1", {
	...f.responsive(css`
		${textStyles.h1};
		color: ${colors.white};
	`),
	...f.tablet(css`
		${textStyles.h3};
	`),
	...f.mobile(css`
		${textStyles.h5};
		text-align: center;
	`),
})

const GreenText = styled("span", {
	...f.responsive(css`
		display: inline-block;
		position: relative;
		color: ${colors.greenAccent};
		transform: skewX(-10deg);
		margin-left: 16px;
	`),
	...f.mobile(css`
		margin-left: 0;
	`),
})

const Subcontent = styled("div", {
	...f.responsive(css`
		display: flex;
		align-items: center;
		padding-left: 32px;
	`),
	...f.mobile(css`
		padding-left: 0;
		flex-direction: column-reverse;
		justify-content: center;
		gap: 30px;
	`),
})

const Text = styled("p", {
	...f.unresponsive(css`
		border-left: 1px solid ${colors.green400};
	`),
	...f.responsive(css`
		width: 432px;
		${textStyles.bodyR};
		color: ${colors.green100};
		padding-left: 32px;
		margin-left: 32px;
	`),
	...f.tablet(css`
		${textStyles.bodyL};
	`),
	...f.mobile(css`
		${textStyles.bodyS};
		border-left: none;
		padding-left: 0;
		margin-left: 0;
		width: 285px;
		text-align: center;
	`),
})

const Bottom = styled("div", {
	...f.responsive(css`
		margin-top: 118px;
		position: relative;
	`),
	...f.tablet(css`
		margin-top: 152px;
	`),
	...f.mobile(css`
		margin-top: 93px;
	`),
})

const BackgroundColor = styled("div", {
	...f.responsive(css`
		background: ${colors.green100Secondary};
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 1312px;
		height: 787px;
		border-radius: 16px 16px 0 0;
		z-index: 0;
	`),
	...f.tablet(css`
		width: 864px;
		height: 554px;
	`),
	...f.mobile(css`
		width: 256px;
		height: 613px;
	`),
})

const Images = styled("div", {
	...f.responsive(css`
		display: flex;
		position: relative;
		z-index: 1;
		gap: 24px;
		width: 1491px;
		margin: 64px 0;
	`),
	...f.tablet(css`
		gap: 29px;
		width: 1800px;
		margin: 68px 0;
	`),
	...f.mobile(css`
		gap: 15px;
		width: 287px;
		margin: 20px 0;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(2, 1fr);
	`),
})

const ImageWrapper = styled("div", {
	...f.unresponsive(css`
		border: 1px solid ${colors.greenAccent};
	`),
	...f.responsive(css`
		padding: 12px;
		border-radius: 18px;
		position: relative;
	`),
	...f.tablet(css`
		border-radius: 16px;
	`),
	...f.mobile(css`
		padding: 6px;
		border-radius: 8px;

		&:last-of-type {
			display: none;
		}
	`),
})

const ImageDetails = styled("div", {
	...f.responsive(css`
		position: absolute;
		top: 24px;
		left: 25px;
		display: flex;
		flex-direction: column;
		gap: 6px;

		p {
			&:last-of-type {
				opacity: 0.75;
			}
		}
	`),
	...f.mobile(css`
		top: 12px;
		left: 12px;
		gap: 5px;
	`),
})

const DetailText = styled("p", {
	...f.responsive(css`
		${textStyles.bodyXXS};
		color: ${colors.white};
	`),
	...f.tablet(css`
		${textStyles.custom.bodyXXSTablet};
	`),
	...f.mobile(css`
		${textStyles.custom.bodyXXSMobile};
	`),
})

const Image = styled(StaticImage, {
	...f.responsive(css`
		width: 255px;
		height: auto;
		border-radius: 12px;
	`),
	...f.tablet(css`
		width: 262px;
	`),
	...f.mobile(css`
		width: 124px;
		border-radius: 6px;
	`),
})
